<template lang="pug">
div
	v-img.py-8.px-md-12.white--text.mb-6(src="https://cdn.wintersport.nl/weblog/3/46008.jpg?width=800" :aspect-ratio="10" gradient="180deg,rgba(37,63,86, 0.4) 0, rgba(2,11,31,0.4)" height="auto")
		.text-center
			h1.h2.display-3.font-weight-bold {{$t('page.insurance.travel:heading')}}
			.h4.title.font-weight-bold {{$t('page.insurance.travel:intro')}}
		v-container
			v-row
				v-col(cols="12" md="6")
					v-card.flex.d-flex.flex-column.pa-md-3(flat color="rgba(255, 255, 255, 0.8)" height="100%")
						v-card-text.flex.font-weight-bold.accent--text
							h2 Doorlopende reisverzekering
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Het hele jaar door ongekend goed verzekerd.
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Het hele gezin gemakkelijk meeverzekeren.
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Kinderen aangemeld voor hun 10e jaar gratis meeverzekerd tot 21 jaar.
						v-card-actions
							v-spacer
							v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}
							v-btn(depressed outlined color="primary" :to="localePath({name:'verzekering-doorlopend'})") meer over doorlopend
							v-spacer
				v-col(cols="12" md="6")
					v-card.flex.d-flex.flex-column.pa-md-3(flat color="rgba(255, 255, 255, 0.8)" height="100%")
						v-card-text.flex.font-weight-bold.accent--text
							h2 Kortlopende reisverzekering
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Voor iedere reis, precies op maat, opnieuw afsluiten.
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Naast het gezin, ook overige familie of vrienden mee te verzekeren.
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Kinderen tot 5 jaar gratis meeverzekerd.
						v-card-actions
							v-spacer
							v-btn(depressed color="warning" :to="localePath({name:'verzekering-kortlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}
							v-btn(depressed outlined color="primary" :to="localePath({name:'verzekering-kortlopend'})") meer over kortlopend
							v-spacer

	insurance-payoff-blocks

	.text-center.mb-6
		v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}

	h2 Échte wintersportdekking
	insurance-info-block

	insurance-sports-tabs

	.text-center.mb-6
		v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}

	insurance-important-documents
</template>

<script>
import insurancePayoffBlocks from '@/components/insurance-payoff-blocks.vue';
import insuranceInfoBlock from '@/components/insurance-info-block.vue';
import insuranceSportsTabs from '@/components/insurance-sports-tabs.vue';
import insuranceImportantDocuments from '@/components/insurance-important-documents.vue';

export default {
	name: 'InsuranceTravel',
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/reisverzekering'
		}
	},
	components: {
		insurancePayoffBlocks,
		insuranceInfoBlock,
		insuranceSportsTabs,
		insuranceImportantDocuments
	},
	layout: 'default',
	scrollToTop: true,
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title:
				'Dé reisverzekering voor wintersporters - Nederlandse Ski Vereniging',
			description:
				'We weten ook dat het aanvinken van het hokje ‘wintersportdekking’ bij een reisverzekering lang niet altijd genoeg is om deze risico’s af te dekken.',
			hasFollow: true,
			hasIndex: true
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.travel:breadcrumb')]: {
				name: 'verzekering-reisverzekering'
			}
		});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
